<template>
	<div class="modal__content">
		<p class="text-center mb20">Are you sure you want to delete this project?</p>

		<div class="flex flex--justify-center">
			<button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">No</button>
			<button class="btn btn--wide" @click="onConfirm">Yes</button>
		</div>
	</div>
</template>

<script>
	export default{
	  data () {
	    return {
	    }
	  },

	  props: ['args'],

	  methods: {
	    onConfirm () {
	      this.$bus.$emit('projectRemove', this.args)
	    }
	  }
	}
</script>



// WEBPACK FOOTER //
// ProjectRemoveModal.vue?28118a36